import { noop, pick } from 'lodash'
import { deserializeAddress } from './utils'
import StripePaymentMethodFields from './StripePaymentMethodFields'
import { GridContainer, GridItem, Field, fieldName, Typography } from '@wolfdanepug/common-react'

const UserAccount = ({ initialState = {} }: any) => {
	return (
		<GridContainer>
			<GridItem md={12}>
				<Typography variant="h4">User Account</Typography>
			</GridItem>
			<GridItem xs={12} md={8}>
				<Field
					label="Email"
					placeholder="Email"
					name={fieldName('email')}
					value={initialState?.email}
					required
				/>
			</GridItem>
			<GridItem xs={12} md={6}>
				<Field
					type="password"
					label="Password"
					placeholder="Password"
					name={fieldName('password')}
				/>
			</GridItem>
		</GridContainer>
	)
}

export default function StripeCheckout({ onChange = noop, initialState = {} }: any) {
	const { shippingAddress, name, phone } = pick(initialState, ['shippingAddress', 'name', 'phone'])
	const address = deserializeAddress(shippingAddress)

	return (
		<GridContainer spacing={4}>
			<GridItem>
				<UserAccount initialState={initialState} />
			</GridItem>
			<StripePaymentMethodFields
				onChange={onChange}
				record={{
					name,
					phone,
					address
				}}
			/>
		</GridContainer>
	)
}
